import React from "react";

const STATUS_STYLES = {
  pending: { bg: "#fff7e6", text: "#b45309", label: "Pending Review" },
  approved: { bg: "#e6f4ea", text: "#137333", label: "Approved" },
  rejected: { bg: "#fce8e6", text: "#c5221f", label: "Rejected" },
  downloaded: { bg: "#e0f2fe", text: "#0369a1", label: "Downloaded" },
};

const buttonBase = {
  border: "none",
  borderRadius: "6px",
  padding: "4px 12px",
  fontSize: "12px",
  fontWeight: "500",
  cursor: "pointer",
};

export default function ClientActionToolbar({
  status,
  price,
  isPaid,
  onApprove,
  onReject,
  onRequestChanges,
  onDownload,
  onPay,
}) {
  const badge = STATUS_STYLES[status] || STATUS_STYLES.pending;
  const numericPrice = Number(price) || 0;
  const isFree = numericPrice <= 0;
  const showPay = status === "approved" && !isFree && !isPaid;
  const downloadEnabled =
    status === "downloaded" || (status === "approved" && (isFree || isPaid));

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "10px",
        padding: "6px 12px",
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <span
          style={{
            background: badge.bg,
            color: badge.text,
            padding: "3px 10px",
            borderRadius: "20px",
            fontSize: "11px",
            fontWeight: "600",
          }}
        >
          {badge.label}
        </span>
        <span style={{ fontSize: "12px", color: "#6b7280" }}>
          Price:{" "}
          <strong style={{ color: "#111827" }}>
            {isFree ? "Free" : `Rs ${numericPrice}`}
          </strong>
          {!isFree && (
            <span
              style={{
                marginLeft: "6px",
                fontWeight: "600",
                color: isPaid ? "#137333" : "#c5221f",
              }}
            >
              {isPaid ? "· Paid" : "· Unpaid"}
            </span>
          )}
        </span>
      </div>

      <div style={{ display: "flex", gap: "10px" }}>
        {status === "pending" && (
          <>
            <button
              onClick={onReject}
              style={{
                ...buttonBase,
                background: "transparent",
                color: "#c5221f",
                border: "1px solid #c5221f",
              }}
            >
              Reject
            </button>
            <button
              onClick={onRequestChanges}
              style={{
                ...buttonBase,
                background: "transparent",
                color: "#b45309",
                border: "1px solid #f59e0b",
              }}
            >
              Request changes
            </button>
            <button
              onClick={onApprove}
              style={{
                ...buttonBase,
                background: "#eef2ff",
                color: "#4f46e5",
              }}
            >
              Approve
            </button>
          </>
        )}

        {showPay && (
          <button
            onClick={onPay}
            style={{
              ...buttonBase,
              background: "#5E5ADB",
              color: "#fff",
            }}
          >
            Pay Rs {numericPrice}
          </button>
        )}

        <button
          onClick={onDownload}
          disabled={!downloadEnabled}
          style={{
            ...buttonBase,
            background: downloadEnabled ? "#5E5ADB" : "#e5e7eb",
            color: downloadEnabled ? "#fff" : "#9ca3af",
            cursor: downloadEnabled ? "pointer" : "not-allowed",
          }}
        >
          Download
        </button>
      </div>
    </div>
  );
}
